import { resetFavoriteArticles } from "modules/Content/Favorites/actions";
import FavoriteNewsContainer from "modules/Content/Favorites/Components/FavoriteNewsContainer";
import ToggleView from "modules/Content/Shared/ToggleView";
import { useEffect, useState } from "react";

type Props = {
  isEdition?: boolean;
};

function FavoritesTab({ isEdition }: Props) {
  const [isListView, setIsListView] = useState(localStorage.getItem("isListView") === "true");

  const handleToggle = (value: boolean) => {
    localStorage.setItem("isListView", `${value}`);
    setIsListView(value);
  };

  useEffect(() => {
    return () => {
      resetFavoriteArticles();
    };
  }, []);

  return (
    <>
      <ToggleView isListView={isListView} onToggle={handleToggle} />
      <FavoriteNewsContainer isListView={isListView} />
      {isEdition && (
        <div className="hidden-stripo" style={{ height: "1px", opacity: "0", overflow: "hidden" }}>
          <div id="load-controls" className="d-none"></div>
          <div id="load-template" className=""></div>
        </div>
      )}
    </>
  );
}

export default FavoritesTab;
